import './Icon_X.css';
import {ReactComponent as CloseIcon} from './Icons_Close_Outline_Brand.svg';
function Icon_X() {
  return (
    <div className='x'>
      <CloseIcon className="x-svg" />
    </div>
  );
}

export default Icon_X;
